import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { getRouteApi } from '@tanstack/react-router'

import { Button } from '@gto/ui/button'

import { sendGaEvent } from '@/gtag'
import { ReportUsernameModal } from '@/pages/deals/components/report-username-modal'

const routeApi = getRouteApi('/_layout/_private/app/deals/$room')

export type DealSignupButtonProps = {
  url: string
  dealId: string
}

export const DealSignupButton = ({ url, dealId }: DealSignupButtonProps) => {
  const { room } = routeApi.useParams()
  const [showModal, setShowModal] = useState(false)

  const onToggleModal = () => {
    setShowModal((prev) => !prev)
  }

  return (
    <>
      <Button
        className="min-w-[150px] flex-initial sm:flex-[1_1_0]"
        color="warning"
        component="a"
        href={typeof url === 'string' ? url : ''}
        rel="noopener noreferrer"
        size="large"
        target="_blank"
        variant="contained"
        onClick={() => {
          sendGaEvent({
            event: 'deal_signup',
            room_name: room,
            deal_id: dealId,
          })
          onToggleModal()
        }}
      >
        <FormattedMessage id="common.controls.signUp" />
      </Button>
      {showModal && (
        <ReportUsernameModal
          fromDeal
          open
          dealId={dealId}
          room={room}
          onClose={onToggleModal}
        />
      )}
    </>
  )
}
